/**
 * Created by comoon on 2/19/16.
 */

var React = require('react');

var moment = require('moment');

module.exports = React.createClass({
    displayName: "Countdown",
    propTypes: {
        left: React.PropTypes.number.isRequired,
        className: React.PropTypes.string,
        minuteText: React.PropTypes.string,
        onInvalid: React.PropTypes.func,
        data: React.PropTypes.object
    },
    getInitialState(){
        return {
            left: this.props.left
        }
    },
    componentWillReceiveProps(nextProps){

        if (nextProps.hasOwnProperty('left')) {

            this.setState({left: nextProps.left});
        }
    },
    componentDidMount(){
        var self = this;
        var left = self.state.left;
        if (left > 0) {
            this.__intervalCountDown = setInterval(function () {
                var left = self.state.left;
                self.setState({left: left - 1});
            }, 1000);
        } else {
            self.props.onInvalid(this.props.data);
        }
    },
    componentWillUnmount(){
        if (this.__intervalCountDown) {
            clearInterval(this.__intervalCountDown);
            delete this.__intervalCountDown;
        }
    },
    componentDidUpdate(){
        if (this.state.left === 0) {
            if (this.__intervalCountDown) {
                clearInterval(this.__intervalCountDown);
                delete this.__intervalCountDown;
            }
            this.props.onInvalid(this.props.data);
        }
    },
    render(){
        var seconds = this.state.left;
        var day = parseInt(seconds / (3600 * 24));
        var hour = parseInt((seconds % (3600 * 24)) / 3600);
        var minute = parseInt((seconds % 3600) / 60);
        var second = seconds % 60;

        /**
         * 未满十位数添加 0 为前缀
         */
        var zeroPipeline = function (num,hasZero) {

            if( hasZero && num < 10 ){
                return `0${ num }`
            }else{
                return num
            }

        };

        return <span className={ this.props.className || "" }>
                {
                    /**
                     * 数字，单位，是否添加 0 前缀
                     */
                    [
                        [day,false,"天"],
                        [hour,false,"小时"],
                        [minute,true,"分"],
                        [second,true,"秒"]

                    ].filter(([num, hasZero])=>

                        num > 0 || ( num == 0 && hasZero )

                    ).map(([num, hasZero, unit],index)=>

                        <span key={ index }><em>{ zeroPipeline(num, hasZero) }</em>{ unit }</span>

                    )
                }
            </span>;
    }
});
 


/** WEBPACK FOOTER **
 ** ./script/cutil/Countdown.jsx
 **/